define('lq/drop',[
    'underscore',
    'jquery',
    'when',
    'lq',
    'lq/oop',
    'lq/observable',
    'lq/validations'
], function (_, $, when, lq, oop, observable, validations) {
    'use strict';

    const masterPageOffsetZIndex = 3000;

    var dropDefaultModel = {
        data: {
            positioning: 'absolute',
            position: { x: 0, y: 0 },
            size: { x: 100, y: 20 },
            zIndex: 1,
            locked: false,
            isHidden: false,
            formatting: {
                dateFormat: 'dd-MM-yyyy',
                groupSeperator: '',
                decimalSeperator: '',
                decimalPrecision: ''
            },
            eventing: {},
            initialVisibility: true,
            initialVisibilityOption: 'Hard Coded',
            centered: false,
            toPage: false
        },
        childDrops: [],
        editable: false,
        renderInBackground: false
    };

    var Drop = function ($element, defaultModel, model) {
        $.extend(true, this, dropDefaultModel, defaultModel, model);

        this.type = this.data.type;

        this.$element = $element
            .addClass('drop-element')
            .css('visibility', 'inherit')
            .data('drop', this);

        this.parent = null;
        this.pool = [];

        this.otherVisuals = [];

        this.eventHandlers = [];    

        observable.makeObservable(this, ['ChildAdded', 'DatasourceApplied', 'Shown', 'Hidden']);

        this.applyLayouts();

        if (typeof Drop.constructing === 'function')
            Drop.constructing(this);

        // this seems a lot easier than if-chaining the constructing method every time
        Drop.informListeners('Constructing', this);
    };

    Drop.prototype.defaultEventArg = undefined;
    Drop.prototype.isHidden = false;
    Drop.prototype.supportsManyToManyData = function () {
        return false;
    };

    oop.makeExtendable(Drop);

    observable.makeObservable(Drop, 'Constructing');

    Drop.prototype.$ = function (selector) {
        return this.$element.find(selector);
    };

    Drop.prototype.autoPositionAt = function (targetPosition) {
        this.$element
            .css({
                left: targetPosition.left === null ? 'auto' : (targetPosition.left + 'px'),
                top: targetPosition.top === null ? 'auto' : (targetPosition.top + 'px'),
                right: targetPosition.right === null ? 'auto' : (targetPosition.right + 'px'),
                bottom: targetPosition.bottom === null ? 'auto' : (targetPosition.bottom + 'px')
            })
            .appendTo($('body'));
    };


    Drop.prototype.createAndRenderDrops = function ($element) {
        var self = this;

        return when(self.preRender())
            .then(function () {
                if (self.removed)
                    return;
                self.$element.appendTo($element);
                _.each(self.childDrops, function(c) {
                    c.rootDrop = self.rootDrop;
                    c.isPeekLayerDrop = self.isPeekLayerDrop;
                });
                var drops = self.piping.dropFactory.createDrops(self.childDrops);
                return when.all(self.createRenderPromisesForChildren(drops));
            })
            .then(function () {
                if (self.data.toBrowser && self.$element && !self.rootDrop.observer) {
                    self.correctToBrowserAnchoring();
                    const observer = new MutationObserver(function () {
                        self.correctToBrowserAnchoring();
                    });
                    const config = {
                        childList: true, // Observe additions/removals of child nodes
                        attributes: true, // Observe changes to attributes
                        attributeOldValue: true, // Record the old value of attributes
                        subtree: true // Observe all descendants of the target
                    };
                    observer.observe(self.$element.siblings('.licquid-action-view')[0], config);
                    self.rootDrop.observer = observer;
                }
                return self.postRender();
            });
    };

    Drop.prototype.isRenderedInBackground = function () {
        if (this.renderInBackground === true)
            return true;
        if (!this.parent)
            return false;
        return this.parent.isRenderedInBackground();
    };

    Drop.prototype.createRenderPromiseForChild = function (drop) {
        if (drop.data.toBrowser) {
            return drop.render(this.piping.$actionWrapper);
        } else if (drop.renderInBackground && this.rootDrop.$masterPage) {
            return drop.render(this.rootDrop.$masterPage);
        } else if (drop.data.toPage && this.rootDrop.$pageAnchored) {
            return drop.render(this.rootDrop.$pageAnchored);
        }

        return drop.render(this.$element);
    };

    Drop.prototype.createRenderPromisesForChildren = function (drops) {
        var self = this;
        var renderPromises = [];

        _.each(drops, function (drop) {
            self.addDrop(drop);
            renderPromises.push(self.createRenderPromiseForChild(drop));
        });

        return renderPromises;
    };

    Drop.prototype.render = function ($element) {
        var self = this;

        return when(self.preRender())
            .then(function () {
                if (self.removed)
                    return;
                if (self.designData && self.designData.renderHidden) self.$element.hide();
                self.$element.appendTo($element);

                var renderPromises = [];

                _.forEach(self.pool, function (drop) {
                    renderPromises.push(self.createRenderPromiseForChild(drop));
                });

                return when.all(renderPromises);
            })
            .then(function () {
                self.renderRuntimeTooltip();
                return self.postRender();
            });
    };

    Drop.prototype.preRender = $.noop;

    Drop.prototype.postRender = $.noop;

    Drop.prototype.resize = function () {
        this.postWindowResize();
        if (this.data.toBrowser && this.$element) {
            this.correctToBrowserAnchoring();
        }
        _.forEach(this.pool, function (drop) {
            //TODO: only call this if this drop is anchored (and resized)
            drop.resize();
        });
    };

    // When a drop is anchored to the browser window
    // the appearance of the scrollbar does not push it away.
    // The function below meant to solve it, by adding a margin
    Drop.prototype.correctToBrowserAnchoring = function() {
        var div = this.$element.parent()[0];
        if (!div)
            return;
        const computedStyle = window.getComputedStyle(div);
        var hasVerticalScrollbar = div.scrollHeight > div.clientHeight;
        var scrollbarWidth = div.offsetWidth - div.clientWidth;
        if (hasVerticalScrollbar && scrollbarWidth > 0) {
            this.$element[0].style.marginRight =
                (scrollbarWidth
                - (parseInt(computedStyle.getPropertyValue('border-left-width'))
                + parseInt(computedStyle.getPropertyValue('border-right-width'))))
                + 'px';
        } else {
            this.$element[0].style.marginRight = '';
        }
    };

    //TODO: should be called postResize
    Drop.prototype.postWindowResize = $.noop;

    Drop.prototype.error = function (errorArgs) {
        this.onError(errorArgs);

        _.forEach(this.pool, function (drop) {
            drop.error(errorArgs);
        });
    };

    Drop.prototype.onError = function (errorArgs) {
    };

    Drop.prototype.isVisible = function () {
        if (this.isHidden)
            return false;

        if (this.parent)
            return this.parent.isVisible();

        return true;
    };

    Drop.prototype.showWithoutAnimation = function () {
        this.getElementForVisibility().removeClass('drop-hidden');
        this.isHidden = false;
        this.shown();
    };

    Drop.prototype.show = function () {
        if (this.animationInProgress)
            return;
        //https://github.com/daneden/animate.css
        var animation = this.data.showAnimation;
        if (animation !== "none" && animation != undefined) {
            var self = this;
            var $el = this.getElementForVisibility();

            var animationStartEvents = 'webkitAnimationStart mozAnimationStart MSAnimationStart oanimationstart animationstart';
            $el.one(animationStartEvents, function () {
                self.animationInProgress = true;
            });

            var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend webkitAnimationCancel mozAnimationCancel MSAnimationCancel oanimationcancel animationcancel';
            $el.one(animationEndEvents, function () {
                $el.removeClass('animated');
                $el.removeClass(animation);
                self.isHidden = false;
                self.shown();
                self.animationInProgress = false;
            });

            if (this.data.showAnimationTime)
                $el.css({animationDuration: this.data.showAnimationTime.delay + this.data.showAnimationTime.unit});
            $el.removeClass('drop-hidden');
            $el.addClass('animated ' + animation);
        } else {
            return this.showWithoutAnimation();
        }
    };

    // will be only called once the page loads, needed because of startViewTransition
    Drop.prototype.initialHide = function () {
        Drop.prototype.hideWithoutAnimation.call(this);
    };

    Drop.prototype.hideWithoutAnimation = function () {
        this.getElementForVisibility().addClass('drop-hidden');
        this.isHidden = true;
        this.hidden();
    };

    Drop.prototype.hide = function () {
        if (this.animationInProgress || this.isHidden)
            return;
        var animation = this.data.hideAnimation;
        //https://github.com/daneden/animate.css
        if (animation !== "none" && animation != undefined) {
            var self = this;
            var $el = this.getElementForVisibility();

            var animationStartEvents = 'webkitAnimationStart mozAnimationStart MSAnimationStart oanimationstart animationstart';
            $el.one(animationStartEvents, function () {
                self.animationInProgress = true;
            });

            var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend webkitAnimationCancel mozAnimationCancel MSAnimationCancel oanimationcancel animationcancel';
            $el.one(animationEndEvents, function () {
                $el.removeClass('animated');
                $el.removeClass(animation);
                $el.addClass('drop-hidden');
                self.isHidden = true;
                self.hidden();
                self.animationInProgress = false;
            });

            if (this.data.hideAnimationTime)
                $el.css({animationDuration: this.data.hideAnimationTime.delay + this.data.hideAnimationTime.unit});
            $el.addClass('animated ' + animation);
        } else {
            this.hideWithoutAnimation();
        }
    };

    Drop.prototype.getElementForVisibility = function () {
        if (this.parent != null) {
            return this.parent.getChildElementForVisibility(this);
        } else {
            return this.$element;
        }
    };

    Drop.prototype.getChildElementForVisibility = function (childDrop) {
        return childDrop.$element;
    };

    Drop.prototype.toggle = function (show) {
        if (arguments.length === 0) {
            show = !this.isVisible();
        }
        if (show)
            this.show();
        else
            this.hide();
    };

    Drop.prototype.shown = function () {
        if (!this.isVisible())
            return;

        this.afterShown();

        this.informListeners('Shown');

        _.forEach(this.pool, function (drop) {
            drop.shown();
        });
    };

    Drop.prototype.afterShown = $.noop;

    Drop.prototype.hidden = function () {
        if (this.isVisible())
            return;

        this.afterHidden();

        this.informListeners('Hidden');

        _.forEach(this.pool, function (drop) {
            drop.hidden();
        });
    };

    Drop.prototype.afterHidden = $.noop;

    Drop.prototype.getEventDataFor = function (eventName) {
        return this.data && this.data.eventing && this.data.eventing[eventName] || {};
    };

    Drop.prototype.applyEventTrigger = function (eventName, jsEventName, $target, eventArg) {
        var self = this;
        $target = $target || self.$element;

        var eventData = this.getEventDataFor(eventName);
        var jsEventNameWithNamespace = jsEventName + ".licquidEventTrigger-" + eventName;

        $target.off(jsEventNameWithNamespace);

        if (eventData.enabled) {
            this.subscribeEventHandler($target, jsEventNameWithNamespace, function () {
                self.triggerEvent(eventData.raisedEventName, eventArg, undefined, undefined, self.isBackgroundEvent(eventName), undefined, undefined, eventName);

                // Modal popups aren't always modal. Needed for the JAO website (and probably other applications as well).
                // A drop inside a list (e.g. a button) should block events from bubbling up,
                // otherwise it could trigger events on both the button and the parent list item (which you probably don't want).
                // A modal popup (without lightbox enabled) will listen to clicks on the document to close itself. However
                // if we were to block the event in the button, the click event will never reach the document and hence
                // the modal won't close. Furthermore, we can't use the lightbox for this purpose because the
                // popup and its lightbox are rendered inside the action (they don't cover the entire page).
                return !self.insideList();
            });
        }
    };

    Drop.prototype.insideList = function () {
        if (!this.parent)
            return false;
        if (this.parent.type === 'List')
            return true;
        return this.parent.insideList();
    };

    Drop.prototype.triggerEventIfEnabled = function (eventName, eventArg, $optionalSource, event) {
        var eventData = this.getEventDataFor(eventName);
        if (eventData.enabled) {
            var isBackgroundEvent = this.isBackgroundEvent(eventName);
            this.triggerEvent(eventData.raisedEventName, eventArg, $optionalSource, event, isBackgroundEvent, undefined, undefined, eventName);
        }
    };

    Drop.prototype.isBackgroundEvent = function (eventName) {
        return (
            eventName === "mouseEnter" ||
            eventName === "mouseLeave" ||
            eventName === "onHtmlElementMouseEntered" ||
            eventName === "onHtmlElementMouseLeft"
        );
    };

    Drop.prototype.isEventEnabled = function (eventName) {
        var eventData = this.getEventDataFor(eventName);
        return eventData.enabled;
    };

    Drop.prototype.triggerEvent = function (raisedEventName, eventArg, $optionalSource, event, isBackgroundEvent, parentEventActionId, callback, eventName) {
        if (!this.piping) return;
        if (_.get(this, ["rootDrop", "pointAndClickActive"], undefined)) return;

        if (eventArg === undefined || eventArg === null)
            eventArg = this.getDefaultEventArg();

        var trigger = $optionalSource || this.$element;

        if (trigger instanceof $)
            trigger = trigger.get(0);

        var eventPosition;
        if (event) {
            eventPosition = {
                clientX: event.clientX,
                clientY: event.clientY,
                offsetX: event.offsetX,
                offsetY: event.offsetY,
                pageX: event.pageX,
                pageY: event.pageY,
                screenX: event.screenX,
                screenY: event.screenY
            };
        }

        var source = {
            drop: this,
            element: trigger,
            activeArea: trigger.getBoundingClientRect(),
            eventPosition: eventPosition,
            isBackgroundEvent: !!isBackgroundEvent,
            eventNameInDrop: eventName
        };

        if (!this.toBeCanceledCanceledByPairs) {
            this.piping.eventing.publish(raisedEventName, source, eventArg, callback, parentEventActionId);
            return;
        }

        var eventPair = this.getEventPairForToBeCanceledEvent(eventName);
        if (this.eventsCancellationHandler) {
            var filtered = _.filter(this.eventsCancellationHandler, function (o) { return o.canceledBy === eventName; });
            if (filtered.length > 0) {
                _.each(filtered, function (o) {
                    o.handle.abort(eventName);
                });
                // Remove filtered objects from eventsCancellationHandler array
                this.eventsCancellationHandler = _.reject(this.eventsCancellationHandler, function (o) { return o.canceledBy === eventName; });
            }
        }

        var eventHandle = this.piping.eventing.publish(raisedEventName, source, eventArg, callback, parentEventActionId);
        
        if (!!eventPair && eventName === eventPair.toBeCanceled) {
            var eventCancellation = {
                canceledBy: eventPair.canceledBy,
                handle: eventHandle
            };
            
            if (this.eventsCancellationHandler) {
                this.eventsCancellationHandler.push(eventCancellation);
            } else {
                this.eventsCancellationHandler = [eventCancellation];
            }
        }
    };

    Drop.prototype.getEventPairForToBeCanceledEvent = function (toBeCanceled) {
        if (!this.toBeCanceledCanceledByPairs) {
            return null;
        }
        return _.chain(this.toBeCanceledCanceledByPairs)
            .filter(function (pair) {
                return pair.toBeCanceled === toBeCanceled;
            }).first().value();
    };

    Drop.prototype.addEventsToBeCanceledAndCanceledBy = function (eventToBeCanceled, eventThatCancels) {
        if (this.toBeCanceledCanceledByPairs) {
            this.toBeCanceledCanceledByPairs.push({
                toBeCanceled: eventToBeCanceled,
                canceledBy: eventThatCancels
            });
        } else {
            this.toBeCanceledCanceledByPairs = [{
                toBeCanceled: eventToBeCanceled,
                canceledBy: eventThatCancels
            }];
        }
    };

    Drop.prototype.getDefaultEventArg = function () {
        if (this.defaultEventArg !== undefined)
            return this.defaultEventArg;

        if (this.parent)
            return this.parent.getDefaultEventArg();

        return undefined;
    };

    Drop.prototype.updateRequiredIndicator = function () {
        if (this.isValid())
            this.$element.addClass('hasValidValue');
        else
            this.$element.removeClass('hasValidValue');
    };

    Drop.prototype.isValid = function () {
        return !this.requiredData || this.hasValue();
    };

    Drop.prototype.triggerValidationEvent = function (optionalParentEventActionId, raisedEventName) {
        this.triggerEvent(raisedEventName, null, null, null, null, optionalParentEventActionId)
    };

    Drop.prototype.performValidation = function (optionalParentEventActionId) {
        return validations.runValidation(this.data.validation, this.piping, this.triggerValidationEvent.bind(this, optionalParentEventActionId), this.getValue());
    };

    Drop.prototype.hasValue = function () {
        var value = this.getValue();

        if (value === undefined || value === null) {
            return false;
        }

        if (value.length === 0) {
            return false;
        }

        return true;
    };

    Drop.prototype.makesItGrow = function () {
        return this.rootDrop && this.rootDrop.doesThisMakeMeGrow(this);
    };

    Drop.prototype.applyPosition = function () {
        if (this.canGrow() || this.makesItGrow()) {
            var css = {
                position: 'relative',
                display: 'block',
                zIndex: this.getZIndex()
            };

            if (this.data.minHeight)
                css.minHeight = this.data.minHeight + 'px';

            // horizontal positioning
            if (this.data.centered === true) {
                css.width = this.data.size.x + 'px';
                css.margin = '0 auto';
            } else if (this.data.right != null && this.data.left == null) {
                css.marginLeft = 'auto';
                css.marginRight = this.data.right + 'px';
                css.width = this.data.size.x + 'px';
            } else if (this.data.right != null && this.data.left != null) {
                css.marginLeft = this.data.left + 'px';
                css.marginRight = this.data.right + 'px';
                css.width = 'calc(100% - ' + this.data.left + 'px' - this.data.right + 'px)';
            } else {
                css.marginLeft = (this.data.left != null ? this.data.left : this.data.position.x) + 'px';
                css.width = this.data.size.x + 'px';
            }

            this.$element.css(css);

            var parentCss = {
                paddingTop: (this.data.top != null ? this.data.top : this.data.position.y) + 'px'
            };

            if (this.data.bottom != null)
                parentCss.paddingBottom = this.data.bottom + 'px';

            if (this === this.rootDrop)
                this.piping.$actionView.css(parentCss);
            else
                this.parent.$element.css(parentCss);

        } else if (this.parent != null && this.parent.parent == null && !this.isRenderedInBackground()) {
            var pool = this.rootDrop.$element[0];

            if (this.$element[0] !== pool) {
                var parent = this.$element.parent()[0];

                if ((this.data.toPage || this.data.toBrowser) && this.rootDrop.$pageAnchored) {
                    var pageAnchoredCanvas = this.rootDrop.$pageAnchored[0];
                    if (parent !== pageAnchoredCanvas)
                        this.$element.appendTo(pageAnchoredCanvas);
                } else if (!this.data.toPage && !this.data.toBrowser) {
                    if (parent !== pool)
                        this.$element.appendTo(pool);
                }
            }

            this.parent.applyPositionForChild(this);
        } else {
            if (this.parent != null) {
                this.parent.applyPositionForChild(this);
            } else {
                this.$element.css(this.getPositionCss(this.data));
            }
        }

        if (this.data.parallax && this.data.parallax.enabled)
            this.piping.$actionWrapper.on('scroll', this.updateParallaxPosition.bind(this));
    };

    Drop.prototype.doesThisMakeMeGrow = function (otherDrop) {
        return false;
    };

    Drop.prototype.canGrow = function (drop) {
        return false;
    };

    Drop.prototype.updateParallaxPosition = function () {
        var scrollTop = this.piping.$actionWrapper.scrollTop();
        this.$element.css('top', this.data.position.y + scrollTop - (scrollTop * this.data.parallax.factor) + 'px');
    };

    Drop.prototype.applyPositionForChild = function (childDrop) {
        var zIndex = childDrop.getZIndex();
        var css =  this.getPositionCss(childDrop.data, zIndex);
        childDrop.$element.css(css);
    };

    Drop.prototype.getZIndex = function () {
        if (!this.renderInBackground && this.parent === this.rootDrop && !this.designData)
            return this.data.zIndex + masterPageOffsetZIndex;
        return this.data.zIndex;
    }

    Drop.prototype.getPositionCss = function (data, optionalZIndex) {
        var zIndex = optionalZIndex !== undefined ? optionalZIndex : data.zIndex;

        if (data.dynamicHeight === true) {
            return {
                position: 'relative',
                top: data.position.y + 'px',
                left: data.position.x + 'px',
                width: data.size.x,
                zIndex: zIndex,
                height: 'auto'
            };
        }

        var css = {
            zIndex: zIndex,
            position: data.positioning
        };

        if (data.useFullScreen) {
            css.left = '0px';
            css.right = '0px';
            css.top = '0px';
            css.bottom = '0px';
            css.height = 'auto';
            css.width = 'auto';
            return css;
        }

        if (data.bottom != null && data.top == null) {
            css.top = 'auto';
            css.bottom = data.bottom + 'px';
            css.height = data.size.y;
        } else if (data.bottom != null && data.top != null) {
            css.top = data.top + 'px';
            css.bottom = data.bottom + 'px';
            css.height = 'auto';
        } else {
            css.top = (data.top != null ? data.top : data.position.y) + 'px';
            css.bottom = 'auto';
            css.height = data.size.y;
        }
        if (data.right != null && data.left == null) {
            css.left = 'auto';
            css.right = data.right + 'px';
            css.width = data.size.x;
        } else if (data.right != null && data.left != null) {
            css.left = data.left + 'px';
            css.right = data.right + 'px';
            css.width = 'auto';
        } else {
            css.left = (data.left != null ? data.left : data.position.x) + 'px';
            css.right = 'auto';
            css.width = data.size.x;
        }

        if (data.centered === true) {
            css.left = '0';
            css.right = '0';
            css.marginLeft = 'auto';
            css.marginRight = 'auto';
        }
        if (data.autoHeight || (data.useDynamicHeight && data.isDynamiclySizedContainer) || (data.isPositionRelative)) {
            css.height = 'auto';
        }

        if (data.autoWidth || (data.useDynamicWidth && data.isDynamiclySizedContainer) || (data.isPositionRelative)) {
            css.width = 'auto';
        }

        if (data.fitContent) {
            css.width = 'fit-content';
        }

        return css;
    };

    Drop.prototype.getPosition = function () {
        var position = {};

        if (this.data.left !== null)
            position.left = this.data.left;

        if (this.data.top !== null)
            position.top = this.data.top;

        if (this.data.right !== null)
            position.right = this.data.right;

        if (this.data.bottom !== null)
            position.bottom = this.data.bottom;

        return position;
    };

    Drop.prototype.addDrop = function (drop) {
        this.pool.push(drop);
        drop.parent = this;
        drop.rootDrop = this.rootDrop;
        drop.piping = this.piping;
        this.informListeners('ChildAdded', drop);
        delete drop.removed;
        return this;
    };

    Drop.prototype.removeDrop = function (drop) {
        drop.beforeRemove();

        if (drop.type === "Query") {
            this.piping.datasources.unregisterDatasource(drop);
        }
        var index = this.pool.indexOf(drop);
        this.pool.splice(index, 1);
        drop.parent = null;
        drop.rootDrop = null;
        drop.piping = null;
        drop.removed = true;

        return this;
    };

    Drop.prototype.beforeRemove = function() {
        _.each(this.pool, function (childDrop) {
            childDrop.beforeRemove();
        });
    };

    Drop.prototype.removeAllDrops = function () {
        var self = this;
        _.each(this.pool.slice(0), function (drop) {
            self.removeDrop(drop);
        });
    };

    Drop.prototype.subscribeEventHandler = function ($element, event, handler) {
        if (typeof arguments[0] === 'string')
            return this.subscribeEventHandler(this.$element, arguments[0], arguments[1]);
        this.eventHandlers.push({ $element: $element, event: event, handler: handler });
        $element.on(event, handler);
    };

    Drop.prototype.registerDisposable = function (disposable) {
        if (!this.disposables) this.disposables = [];
        this.disposables.push(disposable);
    };

    // TODO: implement this in all drops otherwise we leak the whole drop tree when reloading (they all reference eachother)
    // DOM event handlers inside the element of the drop may be removed automatically in newer browsers,
    // but still cause memory leaks in old ones
    // DOM event handlers on document/body/#action-canvas or anything outside the element tree of the action always have to be removed explicitly
    Drop.prototype.unsubscribeEventHandlers = $.noop;

    Drop.prototype.unsubscribeEventHandlersRecursive = function () {
        if (this.rootDrop && this.rootDrop.observer) {
            this.rootDrop.observer.disconnect();
            this.rootDrop.observer = null;
        }
        _.each(this.pool, function (drop) {
            drop.unsubscribeEventHandlersRecursive();
        });

        this.unsubscribeEventHandlers();

        if (this.removeClicks)
            this.removeClicks();

        var self = this;
        _.each(this.eventHandlers, function (eventHandler) {
            if (eventHandler.$element)
                eventHandler.$element.off(eventHandler.event, eventHandler.handler);
            else if (eventHandler.source)
                self.unsubscribe(eventHandler.source, eventHandler.events);
        });

        _.each(this.disposables, function (disposable) {
            disposable.dispose();
        });
        this.disposables = undefined;

        this.parent = null;
        this.rootDrop = null;
        this.piping = null;

        this.$element.remove();
    };

    Drop.prototype.getRootDrop = function () {
        if (this.parent)
            return this.parent.getRootDrop();
        return this;
    };

    Drop.prototype.isChildDropOfRecursive = function (potentialParent) {
        if (this.parent)
            return this.parent === potentialParent || this.parent.isChildDropOfRecursive(potentialParent);
        return false;
    };

    // very simple implementation for now
    Drop.prototype.events = function (source, events, doNotAutoUnsubscribe) {
        _.each(_.keys(events), function (event) {
            var handler = events[event];
            source['withOn' + event](handler);
        });

        // doNotAutoUnsubscribe will default to 'false' if ommitted
        if (doNotAutoUnsubscribe !== true)
            this.eventHandlers.push({ source: source, events: events });
    };

    Drop.prototype.unsubscribe = function (source, events) {
        _.each(_.keys(events), function (event) {
            var handler = events[event];
            source['withoutOn' + event](handler);
        });
    };

    Drop.prototype.descendantOf = function (dropType) {
        if (!this.parent) return false;
        if (this.parent.type === dropType) return true;
        return this.parent.descendantOf(dropType);
    };

    Drop.prototype.getFirstParentOfType = function (dropType) {
        if (!this.parent) return undefined;
        if (this.parent.type === dropType) return this.parent;
        return this.parent.getFirstParentOfType(dropType);
    };

    Drop.prototype.getNestingContext = function () {
        if (!this.parent) return undefined;
        if (this.parent.nestingContext) return this.parent.nestingContext;
        return this.parent.getNestingContext();
    };

    Drop.prototype.applyLayouts = function () {
        if (this.data.appliedLayouts && this.data.appliedLayouts.length > 0) {
            this.$element
                .addClass('layout-specific')
                .addClass(_.map(this.data.appliedLayouts, function (layoutId) {
                    return 'supports-layout-' + layoutId;
                }));
        }
    };

    Drop.prototype.isLoadingStyleEnabled = function () {
        return this.data.stylesExtra?.isLoadingStyleEnabled ?? false;
    };

    Drop.prototype.renderRuntimeTooltip = function () {
        var self = this;
        if (!self.data.runtimeTooltip || self.designData || !lq.isInMockMode()) return;
        var $runtimeTooltip = $("<div>")
            .addClass("runtime-tooltip fa fa-info")
            .appendTo(self.$element);

        var $tooltipClone = $runtimeTooltip.clone().addClass("runtime-tooltip-clone");
        var $popover = $("<div>").addClass("runtime-tooltip-popup")
            .text(self.data.runtimeTooltip);

        var oldOutline;
        $runtimeTooltip.on("mouseenter", function () {
            var pos = $runtimeTooltip[0].getBoundingClientRect();
                $tooltipClone.appendTo("body")
                    .css({
                        top: pos.top + "px",
                        left: pos.left + "px"
                    }); // to ensure full visibility and easy hover
                $popover.appendTo("body")
                    .css({
                        top: pos.top + "px",
                        left: pos.left + pos.width + "px"
                    });
                oldOutline = self.$element.css("outline");
                self.$element.css("outline", "1px dashed #1980aa33");
                $popover.add($tooltipClone).add($runtimeTooltip)
                    .toggleClass("to-left", innerWidth - pos.right < 220);
            });
        var detach = function () {
            $tooltipClone.detach();
            $popover.detach();
            self.$element.css("outline", oldOutline || "");
        };
        $tooltipClone.on("mouseleave", detach);
        $popover.on("mouseenter", detach);
    };

    Drop.prototype.findChildDropWhere = function (predicate) {
        if (predicate(this)) return this;
        if (!Array.isArray(this.pool) || this.pool.length === 0) return false;

        var found = null;
        _.find(this.pool, function (child) {
            found = child.findChildDropWhere(predicate);
            return found;
        });

        return found;
    };

    return Drop;
});
